<template>
  <td v-if="renderCell" class="enum-template" :class="[{ editable: isEditable }, className]" @click="$emit('cellclick', { dataItem, field, event: $event })">
    <template v-if="isEditable">
      <base-el-select ref="cellinput" class="w-full" v-model="localValue" :options="options" size="mini" tabindex="0" @change="$emit('change', null, $event)" @blur="blur" />
    </template>
    <template v-else>
      {{ value }}
    </template>
  </td>
  <td v-else-if="renderArrow" :key="`g-${columnIndex}`" class="k-group-cell" />
  <td v-else-if="renderGroup" key="g-colspan" class="enum-template" :colSpan="columnsCount - columnIndex">
    <p class="k-reset">
      <a @click="$emit('click', $event, dataItem, expanded)" tabIndex="-1" href="#" :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import getNestedValue from '@/services/functions/getNestedValue'
import getEnumTranslatedValue from '@/services/functions/getEnumTranslatedValue'
import { discard } from '@/services/functions/preserve&discard'
import NULL from '@/constants/NULL'

export default {
  name: 'enum-template',
  props: {
    tableId: [String, Number],
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    type: {
      type: String,
      default: 'Text'
    },
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      localValue: ''
    }
  },
  mounted () {
    this.localValue = this.value
    if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
      this.$refs.cellinput.focus()
      this.$refs.cellinput.open()
    }
  },
  watch: {
    idValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
    isEditable: function (value, oldValue) {
      if (value && value !== oldValue) {
        this.$nextTick(() => {
          if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
            this.$refs.cellinput.focus()
          }
        })
      }
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.idValue === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue /* && this.dataItem[this.field] !== undefined */
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    renderGroup () {
      return this.columnIndex <= this.level
    },
    inEdit: function () {
      return getNestedValue(this.editField, this.dataItem) === true
    },
    finalFormats: function () {
      const formats = this.isJSONArray(this.format) ? JSON.parse(this.format) : [this.format]
      return formats.reduce((acc, format) => ({ ...acc, [format]: this.$store.getters[`config/${format}`] }), {})
    },
    options: function () {
      return Object.values(this.finalFormats).filter(x => x).flat()
    },
    value: function () {
      if (this.rowType !== 'groupHeader' || this.field === 'value') {
        const { idEnumField, valueEnumField, ignoreNull } = this
        return getEnumTranslatedValue(this.idValue, this.format, this.field, { idEnumField, valueEnumField, ignoreNull })
      }
      return ''
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams?.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return value
    },
    idValue: function () {
      const value = getNestedValue(this.field, this.dataItem)
      return value === NULL ? null : value
    },
    idEnumField: function () {
      return this.extraparams?.idEnum
    },
    valueEnumField: function () {
      return this.extraparams?.valueEnum
    },
    ignoreNull: function () {
      return this.extraparams?.ignoreNull ?? true
    },
    editable: function () {
      return !!this.extraparams?.editable
    },
    isCellEditable: function () {
      return this.editType === 'cell'
    },
    isEditable: function () {
      return this.editable && this.inEdit && (!this.isCellEditable || this.curEditField === this.field)
    }
  },
  methods: {
    blur (e) {
      if (this.idValue !== this.localValue) {
        this.change(this.localValue)
      }
    },
    isJSONArray: function (value) {
      try {
        return Array.isArray(JSON.parse(value))
      } catch {
        return false
      }
    }
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
.k-grid td.editable {
  text-overflow: clip;
}
.k-grid td.editable::v-deep .el-input__inner {
  min-width: 3rem;
}
</style>
